function isMobileDevice() {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
}

$(document).ready(function () {
    $(".logo-slider").slick({
        infinite: false,
        slidesToShow: 6,
        swipeToSlide: true,
        infinite: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                infinite: true
            }
        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 4,
                dots: true
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick

        }]
    });
    $(document).on('change', '.ath-check', function () {
        // checkNoteField();
        var target = $("#cartAtl");
        if (!this.checked) {
            target.attr("value", "No");
            // $('.ath-check').prop('checked', true);
            $("#cartAtl1")?.attr("value", "No");
        } else {
            target.attr("value", "Yes");
            // $('.ath-check').prop('checked', false); 
            $("#cartAtl1")?.attr("value", "Yes");
        }
    })

    if (isMobileDevice()) {
        $('.accordion-header').click(function () {
            var $currentHeader = $(this);
            var $currentContent = $currentHeader.next('.accordion-content');

            // Check if the current content is already visible
            if ($currentHeader.parent().hasClass('active')) {
                // If it's active, slide it up and remove the active class
                $currentContent.slideUp();
                $currentHeader.parent().removeClass('active');
            } else {
                // If it's not active, remove active class from all and slide up all contents
                $('.accordion-header').parent().removeClass("active");
                $('.accordion-header').next('.accordion-content').slideUp();

                // Then add active class to the clicked header's parent and slide down its content
                $currentHeader.parent().addClass('active');
                $currentContent.slideDown();
            }
        });
    }

    // Attach a click event handler to the summary element
    $('.header__inline-menu summary').on('click', function () {
        // Find the parent link and get its href attribute
        var linkUrl = $(this).find('.parent-link').attr('href');

        // Redirect to the link URL
        if (linkUrl) {
            window.location.href = linkUrl; // Redirect to the URL
        }
    });

    // Add event listener to input for "Enter" key press
    $('#model-number').on('keyup', function (event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
        $('#find-model').click(); // Trigger the search button click
        }
    });

    $('#find-model').on('click', function () {
        var model_number = $("#model-number").val().toLowerCase();

        if (model_number == '') return;

        if (checkModelPDP(model_number)) {
            // $(".model-search-wrapper").addClass("hidden");
            // $(".buy-buttons-wrapper").removeClass("hidden");
            $(".compatible-true").removeClass("hidden");
            $(".compatible-false").addClass("hidden");
        } else {
            $(".compatible-true").addClass("hidden");
            $(".compatible-false").removeClass("hidden");
            
            var filteredProducts = checkModel(model_number);
            if (filteredProducts.length > 0) {
                $(".compatible-false").html("Opps!! This product isn't going to work with your laptop. Our suggestion(s):");
                $(".model-matched-product").empty();
                filteredProducts.forEach((product, index) => {
                    const listItem = document.createElement('li');
                    listItem.id = `predictive-search-option-product-${index + 1}`;
                    listItem.className = 'predictive-search__list-item';
                    listItem.setAttribute('role', 'option');
                    listItem.setAttribute('aria-selected', 'false');

                    listItem.innerHTML = `
                        <a href="${product.url}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">
                            ${product.images.length > 0 ? `
                                <img class="predictive-search__image" src="${product.images[0].src}" alt="${product.images[0].alt}" width="50" height="${50 / product.images[0].aspect_ratio}">
                            ` : ''}
                            <div class="predictive-search__item-content">
                                <p class="predictive-search__item-heading h5">${product.title}</p>
                            </div>
                        </a>
                    `;

                    // Append each item to the results list
                    $(".model-matched-product").append(listItem);
                    $(".model-matched-product").removeClass("hidden");
                });
            } else {
                $(".model-matched-product").empty(); 
                $(".compatible-false").html("Opps!! We didn't find that model number in our records. Could you recheck your laptop's model number and try again?");
            }
        }
    });

    function checkModel(model_number) {
        const lowerCaseModelNumber = model_number.toLowerCase();
    
        const filteredProducts = window.allProducts.filter(product => {
            return product.models.some(model => {
                return model.toLowerCase().trim() === lowerCaseModelNumber.trim();
            });
        });
    
        return filteredProducts;
    }

    function checkModelPDP(model_number) {
      
        if (!window.mainProduct || window.mainProduct.length === 0) {
          return []; // Return an empty array if mainProduct is not valid
        }
      
        const mainProduct = window.mainProduct[0];
      
        if (!Array.isArray(mainProduct.models)) {
          return false; // Return false if mainProduct.models is not valid
        }
      
        const modelMatch = mainProduct.models.some(model => {
          return model.trim().toLowerCase().trim() === model_number.trim().toLowerCase().trim();
        });
      
        return modelMatch; // Return true if found matching, false if not
      }
})